import {GEAR} from './character';
import {skillById,type Shortcut,type ClassId} from './professions';
export function supportedShortcut(binding:Shortcut):boolean {
 if(!binding)return true;
 if(binding.kind==='skill')return !!skillById(binding.id);
 return binding.id==='potion'||binding.id==='capture-talisman'||GEAR.some(g=>g.id===binding.id);
}
export function shortcutRecoveryText(slots:Shortcut[],profession:ClassId,level:number):string {
 const issues=slots.flatMap((binding,i)=>{
  if(!binding)return [];
  if(!supportedShortcut(binding))return [`ช่อง ${i+1}: ไม่พบรายการเดิม · เลือกใหม่ได้`];
  const skill=binding.kind==='skill'?skillById(binding.id):undefined;
  return skill&&(skill.classId!==profession||skill.level>level)?[`ช่อง ${i+1}: ยังใช้วิชานี้ไม่ได้ · เก็บตำแหน่งเดิมไว้`]:[];
 });
 return issues.length?issues.join(' · '):'ไอเทมหมดจะคงช่องเดิม · ช่องว่างหรือรายการเก่าที่ไม่รองรับ: ปลดล็อกแล้วเลือกใหม่ได้';
}
